import * as moment from 'moment-timezone';
import { FormGroup } from '@angular/forms';

export class PaymentFormWidgetJson {
  getWidgetJson(form: FormGroup) {
    return {
      questions: [{
        'type': 'text',
        'name': 'ECControlNumber',
        'identifyingQuestion': true,
        'visible': false
      },
        {
          'type': 'text',
          'name': 'AssociationRequestID',
          'visible': false
        }],
    };
  }
}
